export const config = {
  startPage: 'boot', // Может быть 'welcome', 'maintenance', или 'airdrop'
  airdropAmount: 1000, // Сумма аэйрдропа для пользователя
};